module.exports = __webpack_public_path__ + "img/banner_03.830f24d1.jpg";